import React, { useEffect, useState } from "react";
import './ShortOurProcesses.css';

export default function ShortOurProcesses() {
    const [animate, setAnimate] = useState(false);

  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => setAnimate(true), 300);
    return () => clearTimeout(timer);
  }, []);
  return (
    <>
    <section className="our-process_gg9">
      <h2 className={`section-title_gg9 ${animate ? "fade-in" : ""}`}>
        Our Processes
      </h2>
      <div className="process-grid_gg9">
        {[
          {
            step: "1",
            title: "Client Consultation",
            description:
              "We begin by understanding your business needs and challenges through detailed consultations.",
          },
          {
            step: "2",
            title: "Feasibility Study",
            description:
              "Our team conducts a thorough feasibility analysis to evaluate the best approach for your project.",
          },
          {
            step: "3",
            title: "Planning & Documentation",
            description:
              "We create detailed plans and ensure all necessary documentation is ready for submission.",
          },
          {
            step: "4",
            title: "Approval Submission",
            description:
              "Our experts handle the submission of all required documents to the concerned authorities for approvals.",
          },
          {
            step: "5",
            title: "Compliance Support",
            description:
              "We provide ongoing support to ensure all regulatory compliance requirements are met seamlessly.",
          },
          {
            step: "6",
            title: "Final Approval",
            description:
              "We ensure you receive the final approvals to begin your operations confidently and smoothly.",
          },
        ].map((process, index) => (
          <div
            key={index}
            className={`process-step_gg9 ${animate ? "fade-in-up" : ""}`}
          >
            <span className="step-number_gg9">{process.step}</span>
            <h3>{process.title}</h3>
            <p>{process.description}</p>
          </div>
        ))}
      </div>
    </section>
    
    
    
    
    
    </>
  )
}
